import * as THREE from "three";

import Environment from "./Environment/Environment.js";
import BasePlane from "./Environment/BasePlane.js";

/**
 * The `World` class is responsible for setting up and managing the 3D scene,
 * including the basePlane, environment, and animated elements like the fox.
 * @category Experience
 * @subcategory World
 */
export default class World {
  /**
   * Creates an instance of `World`.
   * Initializes the scene, resources, camera, and event listeners.
   */
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;
    this.down = false;

    this.basePlane = new BasePlane(this.experience);
  }

  cleanup() {
    try {
      // Remove resource event listener
      if (this.resources) {
        this.resources.off("ready");
      }

      // Dispose scene objects (basePlane, environment, fox)
      if (this.basePlane) {
        this.scene.remove(this.basePlane);
        this.disposeObject(this.basePlane);
        this.basePlane = null;
      }

      if (this.fox) {
        this.scene.remove(this.fox);
        this.disposeObject(this.fox);
        this.fox = null;
      }

      if (this.environment) {
        this.scene.remove(this.environment);
        this.disposeObject(this.environment);
        this.environment = null;
      }

      // Remove window event listeners if added
      window.removeEventListener("mousedown", this.onMouseDown);
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);

      // Clear other references
      this.scene = null;
      this.resources = null;
      this.sizes = null;
      this.camera = null;
      this.experience = null;
      this.down = null;

      console.log("World cleanup completed.");
    } catch (error) {
      console.error("Error during World cleanup:", error);
    }
  }

  /**
   * Helper function to dispose of a Three.js object and its materials/geometries.
   * @param {THREE.Object3D} object - The object to dispose of.
   */
  disposeObject(object) {
    if (!object) return;

    object.traverse((child) => {
      if (child.geometry) {
        child.geometry.dispose();
      }
      if (child.material) {
        if (Array.isArray(child.material)) {
          child.material.forEach((material) => material.dispose());
        } else {
          child.material.dispose();
        }
      }
    });
  }

  /**
   * Updates the animation of objects within the scene, such as the fox.
   * This method is called on each frame update.
   */
  update() {
    if (this.fox) this.fox.update();
  }
}
